/* eslint-disable import/no-anonymous-default-export */
export default {
	styleOverrides: {
		root: {
			padding: '1.5em 0em 1em 0em!important',
		},
	},
};
